/*! api-interceptors 2.5.0 */
import { initializeStore as d } from "@seamless/store";
function i(e) {
  return (t) => ({
    ...t,
    withCredentials: e.corsCredentials
  });
}
function I(e) {
  return e.headers.set("Content-Type", "application/json"), e;
}
function l(e) {
  return (t) => (t.headers.set("x-applicationname", e), t);
}
function m() {
  const e = d();
  return new Promise((t) => {
    e.once("B2XCORE_AUTHENTICATION", (r) => {
      t(r.jwe || "");
    });
  });
}
function h(e) {
  return async (t) => {
    if (e && e.some((o) => {
      var c;
      return (c = t.url) == null ? void 0 : c.includes(o);
    }))
      return t;
    const r = await m();
    return r ? t.headers.set("authorization-jwe", `Bearer ${r}`) : t.headers.delete("authorization-jwe"), t;
  };
}
function p(e) {
  return (t) => (t.headers.set({
    "Cache-Control": e != null && e.cacheControl ? e.cacheControl : "no-cache, no-store, must-revalidate",
    Pragma: e != null && e.pragma ? e.pragma : "no-cache"
  }), t);
}
let s;
const y = new Uint8Array(16);
function T() {
  if (!s && (s = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !s))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return s(y);
}
const n = [];
for (let e = 0; e < 256; ++e)
  n.push((e + 256).toString(16).slice(1));
function U(e, t = 0) {
  return n[e[t + 0]] + n[e[t + 1]] + n[e[t + 2]] + n[e[t + 3]] + "-" + n[e[t + 4]] + n[e[t + 5]] + "-" + n[e[t + 6]] + n[e[t + 7]] + "-" + n[e[t + 8]] + n[e[t + 9]] + "-" + n[e[t + 10]] + n[e[t + 11]] + n[e[t + 12]] + n[e[t + 13]] + n[e[t + 14]] + n[e[t + 15]];
}
const w = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), u = {
  randomUUID: w
};
function a(e, t, r) {
  if (u.randomUUID && !t && !e)
    return u.randomUUID();
  e = e || {};
  const o = e.random || (e.rng || T)();
  if (o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, t) {
    r = r || 0;
    for (let c = 0; c < 16; ++c)
      t[r + c] = o[c];
    return t;
  }
  return U(o);
}
const x = a();
function k(e) {
  return e.headers.set("X-SessionId", x), e;
}
function D(e) {
  return e.headers.set("X-TrackingId", a() || ""), e;
}
const S = i, j = I, A = l, C = h, R = p, v = k, B = D;
export {
  j as ContentTypeInterceptor,
  A as GetApplicationNameInterceptor,
  C as GetBearerTokenInterceptor,
  S as GetCorsCredentialsInterceptor,
  R as GetNoCacheInterceptor,
  v as SessionIdInterceptor,
  B as TrackingIdInterceptor
};
